var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 552 138",
    id: "person-default",
    "data-supported-dps": "2048x512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h552v138H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9e5e7",
    d: "M0 0h552v138H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bfd3d6",
    d: "M380 0h172v138H380z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M333.22 0H0v138h333.22a207.93 207.93 0 000-138z",
    fill: "#a0b4b7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerPlaceholder);
export default __webpack_public_path__ + "static/media/banner-placeholder.9d7906e3c426f7f0adbc9d16b6cbf335.svg";
export { ForwardRef as ReactComponent };